/**
 * Created by JIA on 2023/8/17.
 */
import React from "react";
import { Alert, Card, Typography } from "antd";

const { Title, Text } = Typography;

const ErrorView = ({ error, errorInfo }) => (
    <Card style={{ margin: 24 }}>
        <Alert message="应用程序发生错误" description="我们已经记录了这个问题,并将尽快修复" type="error" showIcon />
        <div style={{ marginTop: 16 }}>
            <Title level={4}>错误详情:</Title>
            <Text type="danger">{error?.message}</Text>
            <div style={{ marginTop: 8 }}>
                <Text type="secondary" style={{ whiteSpace: "pre-wrap" }}>
                    {errorInfo?.componentStack}
                </Text>
            </div>
        </div>
    </Card>
);

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }

    static getDerivedStateFromError(error) {
        // 更新状态，以便下一次渲染将显示后备 UI
        return {
            hasError: true,
            error,
        };
    }

    componentDidCatch(error, errorInfo) {
        // 记录错误信息
        this.setState({
            errorInfo,
        });

        try {
            // 构建错误信息对象
            let inVO = {
                errorMessage: error.name + ":" + error.message,
                errorPage: errorInfo?.componentStack?.toString() || "",
                errorTrace: error?.stack?.toString() || "",
            };

            // TODO: 发送错误信息到服务器
            console.error("Error details:", inVO);
        } catch (e) {
            console.error("Error in error reporting:", e);
        }
    }

    render() {
        if (this.state.hasError) {
            const { error, errorInfo } = this.state;
            const { fallback: FallbackComponent } = this.props;

            // 如果提供了 fallback 组件，则渲染它并传入错误信息
            return FallbackComponent ? <FallbackComponent error={error} errorInfo={errorInfo} /> : <ErrorView error={error} errorInfo={errorInfo} />;
        }

        return this.props.children;
    }
}
